const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/featureFlag.ts';
import { createNoAuthPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const REQUEST_ACTION_TYPES_LOAD_FEATURE_FLAGS = kisapiActionTypes('PATAPP_LOAD_FEATUREFLAGS');

export function loadFeatureFlags() {
    const endpoint = `/settings/featureFlags`;
    return createNoAuthPatapiCall(REQUEST_ACTION_TYPES_LOAD_FEATURE_FLAGS, endpoint, HttpMethod.GET);
}
